module.exports = __webpack_public_path__ + "static/media/square@3x.de43b4f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/square@3x.png
// module id = 389
// module chunks = 0 1